import { useEffect, useState } from "react"

/**
 * Отслеживает и возвращает статус сети
 * @hook
 * @category Hook
 */
export function useNetworkStatus() {
	const [status, setStatus] = useState(navigator.onLine ?? true)

	useEffect(() => {
		const onlineHandler = () => setStatus(true)
		const offlineHandler = () => setStatus(false)

		window.addEventListener("online", onlineHandler)
		window.addEventListener("offline", offlineHandler)

		return () => {
			window.removeEventListener("online", onlineHandler)
			window.removeEventListener("offline", offlineHandler)
		}
	}, [])

	return status
}
